import Course from 'src/model/Course';

const courseDatabaseMap: Map<string, Course> = new Map<string, Course>([
  [
    'coding_interview',
    {
      courseId: 'coding_interview',
      title: 'Coding Interview',
      description: 'Technical coding interview focused on data structures and algorithms.',
      image: 'resource/course/coding_interview/course_card.png',
    },
  ],
  [
    'coming_soon',
    {
      courseId: 'coming_soon',
      title: 'Future Course',
      description: 'Coming Soon!',
      image: 'resource/course/coming_soon/course_card.png',
    },
  ],
]);

export default courseDatabaseMap;
